module.exports = __webpack_public_path__ + "img/faculty.c109806c.png";